
import axiosInstance from "./axiosInstance";

const BASE = "/dashboard/reviews";

// GET /dashboard/reviews/?product=&is_approved=&rating=&search=&page=
export const getReviews = (params) =>
  axiosInstance.get(`${BASE}/`, { params });

// POST /dashboard/reviews/create/
export const createReview = (payload) =>
  axiosInstance.post(`${BASE}/create/`, payload);

// PATCH /dashboard/reviews/<id>/
export const updateReview = (id, payload) =>
  axiosInstance.patch(`${BASE}/${id}/`, payload);

// DELETE /dashboard/reviews/<id>/
export const deleteReview = (id) =>
  axiosInstance.delete(`${BASE}/${id}/`);

// POST /dashboard/reviews/<id>/toggle-approval/
export const toggleReviewApproval = (id) =>
  axiosInstance.post(`${BASE}/${id}/toggle-approval/`);